import React from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import TextEditor from "components/textEditor/TextEditor";
import ImageUploader from "components/image-upload/ImageUploader";

const PredictionView = ({ prediction, isEditable }) => {
  const { t } = useTranslation();
  const coverUrl =
    prediction?.images?.cover &&
    (typeof prediction?.images?.cover === "string"
      ? prediction?.images?.cover
      : URL.createObjectURL(prediction?.images?.cover));
  const thumbnailUrl =
    prediction?.images?.thumbnail &&
    (typeof prediction?.images?.thumbnail === "string"
      ? prediction?.images?.thumbnail
      : URL.createObjectURL(prediction?.images?.thumbnail));
  return (
    <div className="h-full bg-cover bg-center mb-40 group">
      {thumbnailUrl && (
        <div className="relative">
          <ImageUploader
            isDisabled={!isEditable}
            imageComponent={
              <div
                className="relative w-full h-64 bg-black bg-opacity-50 hover:bg-gray-800"
                style={{ backgroundImage: `url(${thumbnailUrl})` }}
              />
            }
            text={t("programs.cover")}
            image={prediction?.images?.thumbnail || ""}
            setImage={(file, url) => {}}
          />
          {coverUrl && (
            <div className="absolute right-20 -bottom-20">
              <ImageUploader
                isDisabled={!isEditable}
                imageComponent={
                  <img
                    alt="group cover"
                    src={coverUrl}
                    className="rounded-md h-40 w-40"
                  />
                }
                text={t("programs.thumbnail")}
                image={coverUrl}
                setImage={(file, url) => {}}
              />
            </div>
          )}
        </div>
      )}
      <div className="px-10">
        <div className="w-full bg-white flex flex-row">
          <div className="w-3/4 my-auto">
            <Typography gutterBottom variant="h3" component="div">
              {prediction?.title}
            </Typography>
            <Typography gutterBottom variant="body1" component="span">
              {prediction?.description}
            </Typography>
          </div>
        </div>
        <div className="overflow-y-visible mb-24 mt-8">
          <Typography
            className="text-center w-3/4 mx-auto"
            gutterBottom
            variant="h4"
            component="div"
          >
            {prediction?.goal}
          </Typography>
          <div className="w-full">
            {prediction?.content && (
              <TextEditor
                isEditable={isEditable}
                value={prediction?.content}
                height="100%"
                width="100%"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PredictionView;
